import axios from "axios";

export function apiGetNotifications(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/notifications" +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetNotification(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/notifications/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveNotification(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/notifications", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateNotification(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/notifications/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteNotification(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/notifications/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
